<template>
  <a href="#" class="navbar-nav-link align-items-center rounded-pill p-1" data-bs-toggle="dropdown">
    <div class="status-indicator-container">
      <img :src="this.userInfo?.UserImage ?? `${require('@/assets/images/icons/face_default.png')}`"
        class="w-32px h-32px rounded-pill" alt="" style="background-color: white;" />
      <span class="status-indicator bg-success"></span>
    </div>
    <span class="d-none d-lg-inline-block mx-lg-2">{{ useAuthAppStore?.getParsedToken?.userName ?? '-' }}</span>
  </a>

  <div class="dropdown-menu dropdown-menu-end">
    <router-link to="/user/user-profile" class="dropdown-item" aria-disabled="true">
      <i class="ph-user-circle me-2"></i>
      {{ $t('My_Profile') }}
    </router-link>
    <!-- burası rolle baglanacak. kullanicinin rolu varsa eger buraya erisebilecek -->
    <router-link to="/user" class="dropdown-item" v-if="isAdminUser">
      <i class="ph-currency-circle-dollar me-2"></i>      
      {{ $t('User_Management') }}
    </router-link>
    <div class="dropdown-divider"></div>
    <a href="#" class="dropdown-item disabled" aria-disabled="true">
      <i class="ph-gear me-2"></i>
      {{ $t('Account_Settings') }}
    </a>
    <a class="dropdown-item" @click="SetLogOut()" style="cursor: pointer;">
      <i class="ph-sign-out me-2"></i>
      {{ $t('Logout') }}
    </a>
  </div>
</template>
<script>
import { useAuthAppStore } from '@/store/stores/authStore.js';

export default {
  name: "LoginPage",
  methods: {
    SetLogOut() {
      this.useAuthAppStore?.setLogOut()
      this.$router.push('/login');
    }
  },
  data() {
    return {
      userInfo: null,
      useAuthAppStore: useAuthAppStore(),
      isAdminUser: false
    }
  },
  created() {
    this.isAdminUser = this.useAuthAppStore?.getParsedToken?.roles?.includes('Admin');
  },
}
</script>
<style></style>
